import { render, staticRenderFns } from "./BookingsBoard.vue?vue&type=template&id=b7141d60&scoped=true"
import script from "./BookingsBoard.vue?vue&type=script&lang=js"
export * from "./BookingsBoard.vue?vue&type=script&lang=js"
import style0 from "./BookingsBoard.vue?vue&type=style&index=0&id=b7141d60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7141d60",
  null
  
)

export default component.exports